"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("@material-ui/core/styles");
const Radio_1 = __importDefault(require("@material-ui/core/Radio"));
require("./radioButtonsList.scss");
const useStyles = styles_1.makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px #999999, inset 0 0px 0 rgba(16,22,26,.1)',
        backgroundColor: 'fff',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '1px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#fff',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#2EA0DC',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        boxShadow: 'none',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 28%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#2EA0DC',
        },
    },
});
const RadioButtonsList = (props) => {
    const classes = useStyles();
    const { data, handleChangeEvent, filterType, filterData } = props;
    const list = data.map((el, i) => {
        return (react_1.default.createElement("div", { key: i, className: 'container-wrapper' },
            react_1.default.createElement(Radio_1.default, { id: `radio-${i}`, checked: el.key.toString() === filterData[0], onClick: (e) => {
                    handleChangeEvent(e.target.value, filterType);
                }, className: classes.root, value: el.key, disableRipple: true, color: "default", checkedIcon: react_1.default.createElement("span", { className: clsx_1.default(classes.icon, classes.checkedIcon) }), icon: react_1.default.createElement("span", { className: classes.icon }) }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", { style: { cursor: "pointer" }, htmlFor: `radio-${i}` }, el.value))));
    });
    return (react_1.default.createElement("div", { className: 'radio-btns-list' }, list));
};
exports.default = RadioButtonsList;
